import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'families',
		pathMatch: 'full'
	},
	{
		path: 'survey',
		loadChildren: () => import('./pages/survey/survey.module').then((m) => m.SurveyPageModule)
	},
	{
		path: 'start',
		loadChildren: () => import('./pages/start/start.module').then((m) => m.StartPageModule)
	},
	{
		path: 'families',
		loadChildren: () => import('./pages/families/families.module').then((m) => m.FamiliesPageModule)
	},
	{
		path: 'families/:id',
		loadChildren: () => import('./pages/families/families.module').then((m) => m.FamiliesPageModule)
	},
	{
		path: 'about-adoption',
		loadChildren: () => import('./pages/about-adoption/about-adoption.module').then((m) => m.AboutAdoptionPageModule)
	},
	{
		path: 'contact',
		loadChildren: () => import('./pages/contact/contact.module').then((m) => m.ContactPageModule)
	},
	{
		path: 'p/:id',
		loadChildren: () => import('./pages/family/family.module').then((m) => m.FamilyPageModule)
	},
	{
		path: 'p/:id/stories/:topic',
		loadChildren: () => import('./pages/stories/stories.module').then((m) => m.StoriesPageModule)
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
	exports: [RouterModule]
})
export class AppRoutingModule {}
